import React from 'react'

interface PropsType {
	/** 넘어갈 사이트 밖 주소 */
	to: string
}

/**
 * 사이트 밖으로 넘기는 라우트 원소. 지금은 `/forum` → forum.judahs.io 한 군데가 쓴다
 * (2026-09-10, FORUM_PLAN §14.9 Phase 5).
 *
 * CRA + S3/CloudFront 라 서버 301 을 낼 자리가 없다 — `replace` 로 히스토리에 남기지 않아
 * 뒤로 가기가 이 경로로 되돌아오지 않게 한다. 진짜 301 은 CloudFront Function 이 필요하다.
 * 화면은 그리지 않는다. 예고 문구를 두면 빈 페이지를 하나 더 만드는 셈이다.
 */
export const ExternalRedirect = (props: PropsType): null => {
	React.useEffect(() => {
		window.location.replace(props.to)
	}, [props.to])

	return null
}
